import type { ConfigType, Dayjs } from 'dayjs'
import type { Range } from 'react-date-range'

import { appDay } from 'shared/day.ts'

export type LocalRange = {
	end: Dayjs
	start: Dayjs
}

function saveSameTimeInUtc(input: ConfigType) {
	const asDay = appDay(input)
	const offset = asDay.utcOffset()

	return asDay.utc().add(offset, 'minutes')
}

const fromDay = ({ end, start }: LocalRange): Range[] => [
	{
		color: '#0cb39f',
		endDate: end.toDate(),
		key: 'selection',
		startDate: start.toDate()
	}
]

const fromPicker = ([{ endDate, startDate }]: Range[]): LocalRange => ({
	end: saveSameTimeInUtc(endDate).endOf('day'),
	start: saveSameTimeInUtc(startDate).startOf('day')
})

export { fromDay, fromPicker }
